export const accountUtil = {
  findAccount(accounts: ContractAccount[], settleCurrency: string): ContractAccount {
    return accounts.find((account) => account.currency === settleCurrency) || initAccount(settleCurrency);
  },
};

function initAccount(currency): ContractAccount {
  const precision = currency === 'USD' ? 2 : 8;
  const str = (0).toFixed(precision);
  const str4 = (0).toFixed(4);
  const strWU = str + ' ' + currency;
  const str4WU = str4 + ' ' + currency;
  return {
    currency,
    accountBalanceEv: 0,
    accountBalance: str,
    totalUsedBalanceEv: 0,
    totalUsedBalance: str,
    availableBalanceEv: 0,
    availableBalance: str,
    availableBalanceWU: strWU,
    availableBalance2: str,
    availableBalance2WU: strWU,
    availableBalance4: str4,
    availableBalance4WU: str4WU,
    availableTransferBalanceEv: 0,
    availableTransferBalanceWU: strWU,
    availableTransferBalance2WU: strWU,
    bonusBalanceEv: 0,
    bonusBalance: str,
    equityEv: 0,
    equity: str,

    unrealisedPnlEv: 0,
    unrealisedPnl: str,
    marginBalanceEv: 0,
    marginBalance: str,
    positionMarginEv: 0,
    positionMargin: str,
    orderMarginEv: 0,
    orderMargin: str,
  };
}
